<template>
    <figure
        id="floor-selection"
    >
        <div class="flex gap-6">
            <div class="flex-grow">
                <v-option-dropdown class="z-50" no-input :options="floorOptions" name="floorSelection" label="Izberite nadstropje" :default-value="getDefaultFloor" :on-change="onFloorChange"/>
            </div>
            <div
                v-if="selectedFloor == 1"
                :class="[
                    'input group',
                    validationErrors.etage ? 'has-errors' : '',
                ]"
            >
                <input
                    id="floorInput"
                    type="number"
                    name="floorInput"
                    placeholder="Številka nadstropja"
                    v-model="floorInput"
                />
            </div>
        </div>
        <div class="mt-2 text-small-text-regular text-gray-400" v-if="selectedFloor == 1">
            <span>Vnesite številko nadstropja v drugo polje</span>
        </div>

        <!--<div
            class="creative absolute right-[164px] flex h-[480px] w-[240px] lg:relative lg:right-auto"
        >
            <img
                :src="$assetsUrl + '/images/floor-min.webp'"
                alt="Klet"
                id="imgKlet"
                class="floor pointer-events-none absolute left-0 top-0 h-[480px] w-[240px] select-none opacity-100"
                v-if="selectedFloor == -1"
            />
            <img
                :src="$assetsUrl + '/images/floor-0.webp'"
                alt="Pritličje"
                id="imgPritlicje"
                class="floor pointer-events-none absolute left-0 top-0 h-[480px] w-[240px] select-none opacity-100"
                v-if="selectedFloor == 0"
            />
            <img
                :src="$assetsUrl + '/images/floor-floor.webp'"
                alt="Nadstropje"
                id="imgNadstropje"
                class="floor pointer-events-none absolute left-0 top-0 h-[480px] w-[240px] select-none opacity-100"
                v-if="selectedFloor == 1"
            />
            <img
                :src="$assetsUrl + '/images/floor-max.webp'"
                alt="Podstrešje"
                id="imgPodstresje"
                class="floor pointer-events-none absolute left-0 top-0 h-[480px] w-[240px] select-none opacity-100"
                v-if="selectedFloor == 2"
            />
        </div>
        <div
            class="legend absolute right-0 mr-[-70px] flex h-[480px] w-full min-w-[1px] max-w-[240px] flex-1 gap-4 lg:relative lg:mr-auto"
        >
            <div
                :class="[
                    'floor-legend group',
                    validationErrors.etage ? 'has-errors' : '',
                ]"
            >
                <input
                    id="floor"
                    type="range"
                    min="-1"
                    max="2"
                    step="1"
                    class="cursor-pointer appearance-none"
                    v-model="selectedFloor"
                />
                <span class="relative mt-4 block w-[420px]">
                    <div
                        id="pingKlet"
                        :class="[
                            selectedFloor == -1 ? 'active opacity-100' : '',
                            'ping absolute left-[30px] flex h-4 origin-top-left rotate-90 cursor-pointer gap-2',
                        ]"
                        @click="handleFloorChange(-1)"
                    >
                        <v-icon
                            icon="basement"
                            size="4"
                            class="text-black-40"
                        ></v-icon>
                        <div class="text-body-medium text-black-40">Klet</div>
                    </div>
                    <div
                        id="pingPritlicje"
                        :class="[
                            selectedFloor == 0 ? 'active opacity-100' : '',
                            'ping absolute left-[153px] flex h-4 origin-top-left rotate-90 cursor-pointer gap-2',
                        ]"
                        @click="handleFloorChange(0)"
                    >
                        <v-icon
                            icon="door"
                            size="4"
                            class="text-black-40"
                        ></v-icon>
                        <div class="text-body-medium text-black-40">
                            Pritličje
                        </div>
                    </div>
                    <div
                        id="pingNadstropje"
                        :class="[
                            selectedFloor == 1 ? 'active opacity-100' : '',
                            'ping absolute left-[282px] flex h-4 origin-top-left rotate-90 cursor-pointer flex-col gap-2',
                        ]"
                        @click="handleFloorChange(1)"
                    >
                        <div class="flex gap-2">
                            <v-icon
                                icon="stairs"
                                size="4"
                                class="text-black-40"
                            ></v-icon>
                            <div class="text-body-medium text-black-40">
                                Nadstropje
                            </div>
                        </div>
                        <div class="floor-number-form hidden">
                            <div
                                :class="[
                                    'input group relative flex flex-col gap-[10px]',
                                    validationErrors.etage ? 'has-errors' : '',
                                ]"
                            >
                                <input
                                    id="floorInput"
                                    type="number"
                                    name="floorInput"
                                    placeholder="Število"
                                    v-model="floorInput"
                                />
                                <small
                                    class="hidden text-small-text-regular text-salmon"
                                    >Prosimo vnesite v katerem nadstropju se
                                    nahaja stanovanje</small
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        id="pingPodstresje"
                        :class="[
                            selectedFloor == 2 ? 'active opacity-100' : '',
                            'ping absolute left-[406px] flex h-4 origin-top-left rotate-90 cursor-pointer gap-2',
                        ]"
                        @click="handleFloorChange(2)"
                    >
                        <v-icon
                            icon="roofing"
                            size="4"
                            class="text-black-40"
                        ></v-icon>
                        <div class="text-body-medium text-black-40">
                            Podstrešje
                        </div>
                    </div>
                </span>
            </div>
        </div>
        -->
        <input type="hidden" name="etage" v-model="floorNumber" />
    </figure>
</template>

<script>
import OptionDropdown from './OptionDropdown.vue';

export default {
    components: {
        "v-option-dropdown": OptionDropdown
    },
    props: {
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        onFloorChanged: {
            type: Function,
            required: true,
        },
        defaultFloor: {
            type: Number,
            required: false,
            default: 1,
        }
    },

    data() {
        return {
            selectedFloor: 1,
            floorNumber: 0, // submited value
            floorInput: 1,
        };
    },
    mounted() {
        this.floorNumber = this.defaultFloor;
        this.floorInput = (this.defaultFloor > 0 && this.defaultFloor < 9999) ? this.defaultFloor : 1;

        if(this.defaultFloor == 9999)
            this.selectedFloor = 2;

        if(this.defaultFloor <= 0)
            this.selectedFloor = this.defaultFloor;
    },
    watch: {
        floorInput: {
            handler: function (val, oldVal) {
                this.floorNumber = this.floorInput;
            },
        },
        selectedFloor: {
            handler: function (val, oldVal) {
                this.setFloorNumber();
            },
        },
        floorNumber: {
            handler: function (val, oldVal) {
                this.onFloorChanged(val)
            },
        }
    },
    computed: {
        getDefaultFloor() {
            if(this.defaultFloor == 9999)
                return 2;

            if(this.defaultFloor <= 0)
                return this.defaultFloor;

            return 1;
        },
        floorOptions() {
            return [
                {'label': 'Podstrešje', 'value': 2},
                {'label': 'Nadstropje', 'value': 1},
                {'label': 'Pritličje', 'value': 0},
                {'label': 'Klet', 'value': -1},
            ];
        }
    },
    methods: {
        onFloorChange(newFloor) {
            this.handleFloorChange(newFloor);
        },
        setFloorNumber() {
            /**
             * selectedFloor = -1 => floorNumber = selectedFloor
             * selectedFloor = 0 => floorNumber = selectedFloor
             * selectedFloor = 1 => floorNumber = floorInput set by watcher but first set the value of current input value
             * selectedFloor = 2 => floorNumber = 9999
             */
             if (this.selectedFloor == -1 || this.selectedFloor == 0) {
                this.floorNumber = this.selectedFloor;
            }

            if (this.selectedFloor == 1) {
                this.floorNumber = this.floorInput;
            }

            if (this.selectedFloor == 2) {
                this.floorNumber = 9999;
            }
        },
        handleFloorChange(selectedFloor) {
            this.selectedFloor = selectedFloor;
        },
    },
};
</script>
